import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import { Box, Paper, Typography, useTheme } from "@mui/material";
import { tokens } from "../../../theme";

const suggestions = [
  { icon: <WhatsAppIcon fontSize="large" />, label: "Send registration form via WhatsApp" },
  { icon: <MailOutlineIcon fontSize="large" />, label: "Send Activation Email" },
  { icon: <ArticleOutlinedIcon fontSize="large" />, label: "Request missing documents" },
  { icon: <ArticleOutlinedIcon fontSize="large" />, label: "Request missing documents" },
];

export default function SmartSuggestionsCard() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: "20px",
        p: 2.5,
        backgroundColor: colors.primary[900],
        height: "100%",
      }}
    >
      <Typography sx={{ fontSize: "1rem", fontWeight: 600, mb: 2 }}>
        Smart Suggestions
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.2 }}>
        {suggestions.map((s, i) => (
          <Box
            key={i}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              backgroundColor: "#F3F5F8",
              borderRadius: "12px",
              px: 2,
              py: 1.4,
              cursor: "pointer",
              "&:hover": { backgroundColor: "#E8ECF1" },
            }}
          >
            <Box sx={{ color: "#6E7885", display: "flex" }}>{s.icon}</Box>
            <Typography sx={{ fontSize: "0.9rem", color: "#4E5969" }}>
              {s.label}
            </Typography>
          </Box>
        ))}
      </Box>
    </Paper>
  );
}